import Canned                                                from '../../../pages/support/Canned';
import { getSupportCannedEditRoute, getSupportCannedsRoute } from './factory/canned';
import EditCanned                                            from '../../../pages/support/EditCanned';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
	{
		path: getSupportCannedsRoute(),
		component: Canned,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getSupportCannedEditRoute(),
		component: EditCanned,
		exact: false,
		type: 'route',
		loginRequired: true,
	},
];

export default routes;
